export default {
  data() {
    return {
      // empty
    };
  },
  computed: {
    icons() {
      return this.$store.getters["Icon/icons"];
    },
    fullNavLabels() {
      return this.$store.getters["Product/fullNavLabels"];
    },
    subMenuItems() {
      return this.$store.getters["Drawer/subMenuItems"];
    },
    isProfileComplete() {
      if (
        this.$store.getters["Profile/personalInfo"].firstName.value.length > 0 &&
        this.$store.getters["Profile/personalInfo"].lastName.value.length > 0 &&
        this.$store.getters["Profile/personalInfo"].gender.value.length > 0 &&
        this.$store.getters["Profile/personalInfo"].dateOfBirth.value.length > 0 &&
        this.$store.getters["Profile/locationInfo"].cityProvince.value.length > 0 &&
        this.$store.getters["Profile/locationInfo"].postalCode.value.length > 0 &&
        this.$store.getters["Profile/locationInfo"].address1.value.length > 0 &&
        this.$store.getters["Profile/contactInfo"].mobile.value.number.length > 0
        )
      {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    async refreshAPI() {
      this.$store.dispatch("API/refreshAPI");
    },
    changeRoute(path) {
      path !== this.$route.path && this.$router.push(path);
    },
    openSnackbar(payload) {
      this.$store.dispatch("Snackbar/updateSnackbar", payload);
    },
    disableContextMenu: function(e) {
      e.preventDefault();
    },
  },
};
